import * as d3 from 'd3';
import { interpolateRdBu } from 'd3-scale-chromatic';
import { lighten } from 'colorutilities';

const climateColorScale = d3.scaleSequential(interpolateRdBu).domain([1, 8]);

const climateColors = [
  lighten(climateColorScale(2), 10),
  lighten(climateColorScale(3), 0),
  lighten(climateColorScale(3), 15),
  lighten(climateColorScale(4), 0),
  lighten(climateColorScale(5), 0),
  lighten(climateColorScale(6), 10),
  lighten(climateColorScale(7), 50),
  lighten(climateColorScale(7), 0),
];

const calculateClimateColor = d => {
  const { climateZone } = d.properties;
  return climateColors[climateZone - 1];
};

export { calculateClimateColor };



// WEBPACK FOOTER //
// ./src/App/ClimateZoneColors.js